import React, { FC } from 'react';
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { alertListType } from 'features/alerts/types';
import { useTranslation } from 'react-i18next';
import NormalTableRow from './NormalTableRow';
import { headerStyle } from './styles';

type Props = {
  alertList: alertListType;
  setSelectedRow: React.Dispatch<React.SetStateAction<number | null>>;
  selectedRow: number | null;
  handleDeleteClick: (id: string) => () => Promise<void>;
};

const AlertsTable: FC<Props> = ({ alertList, setSelectedRow, selectedRow, handleDeleteClick }) => {
  const { t } = useTranslation();
  const data = alertList.map((d, idx) => {
    return {
      idx: idx + 1,
      name: d.name,
      address: d.address,
      id: d.id,
      conditions: d?.conditions || [],
      is_area: d?.is_area || false,
      station: d?.station || null,
    };
  });

  return (
    <TableContainer
      component={Paper}
      style={{ height: '40vh', overflowY: 'scroll', borderRadius: '0px' }}
    >
      <Table aria-label="editable table" stickyHeader>
        {/* ヘッダー部分 */}
        <TableHead>
          <TableRow>
            <TableCell style={headerStyle}>
              <Checkbox disabled />
            </TableCell>
            <TableCell style={headerStyle}>{t('pages.alerts.areaName')}</TableCell>
            <TableCell style={headerStyle}>{t('pages.alerts.variable')}</TableCell>
            <TableCell style={headerStyle}>{t('pages.alerts.address')}</TableCell>
            <TableCell style={headerStyle}>
              <>
                {t('pages.alerts.pointOrArea')}
                <Tooltip title={t('pages.alerts.tooltip.areaOrPoint')}>
                  <HelpOutlineIcon style={{ cursor: 'pointer', marginLeft: 2, fontSize: '14px' }} />
                </Tooltip>
              </>
            </TableCell>
            <TableCell style={headerStyle}>{t('pages.alerts.numOfConditions')}</TableCell>
            <TableCell style={headerStyle}></TableCell>
          </TableRow>
        </TableHead>

        {/* テーブル本体 */}
        <TableBody>
          {data.map((d, idx) => (
            <NormalTableRow
              d={d}
              setSelectedRow={setSelectedRow}
              isSelected={idx === selectedRow}
              handleDeleteClick={handleDeleteClick}
              idx={idx}
              key={idx}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AlertsTable;
